import {
  Steps as AntdSteps,
  StepsProps as AntdStepsProps,
  StepProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";
import { StepCheckIcon, StepDotIcon } from "@/base/static/index";

export interface StepsProps extends AntdStepsProps {}

export const stepsPrefixCls = `${CMP_PREFIX}-steps`;

export const Steps = ({ items, ...props }: StepsProps) => {
  return (
    <AntdSteps
      items={items?.map((item: StepProps) => ({
        ...item,
        icon:
          item.icon ||
          (item.status === "finish" ? <StepCheckIcon /> : <StepDotIcon />),
      }))}
      {...props}
    />
  );
};
